import { PlusCircle } from "react-bootstrap-icons";
import { useArsListing } from "./ArsListingContextProvider";
import { ARSL_ADD_BLANK_COLUMN } from "./interface";

/**
 * Renders a button to add a new column to the listing.
 * The button is only displayed if the listing is not disabled.
 * When clicked, it dispatches an action to add a new column with the last column's ID.
 *
 * @returns Add column button component
 */
export const ArsListingAddColumnButton = <T,>(): React.ReactNode => {
  const { state, dispatch } = useArsListing<T>();
  if (!state || state.settings.disabled) return null;

  const totalCols = state.bodyData.arsListingColumns.length;

  return (
    <div
      className="ars-listing-add-column-button"
      title="Add blank column"
      role="button"
      tabIndex={0}
      onClick={() => {
        const colId = crypto.randomUUID();
        dispatch({
          operation: ARSL_ADD_BLANK_COLUMN,
          colIx: totalCols,
          colId,
        });
      }}
    >
      <PlusCircle aria-label="Add column" />
    </div>
  );
};

ArsListingAddColumnButton.displayName = "ArsListingAddColumnButton";
